import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  ensureGrafanaLogin,
  hasGrafanaLogin,
} from "../../../../components/SupabaseClient";

const ProtectedGrafanaFrame = ({ src, title, sx }) => {
  const [status, setStatus] = useState(() =>
    hasGrafanaLogin() ? "ready" : "loading",
  );

  useEffect(() => {
    let active = true;

    const establishGrafanaLogin = async () => {
      try {
        if (!hasGrafanaLogin()) {
          setStatus("loading");
        }
        await ensureGrafanaLogin();
        if (active) setStatus("ready");
      } catch (err) {
        console.error("[ProtectedGrafanaFrame] Failed to load dashboard:", err);
        if (active) setStatus("error");
      }
    };

    establishGrafanaLogin();

    return () => {
      active = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <Box
        sx={{
          display: "grid",
          height: `calc(100vh - ${60}px)`,
          placeItems: "center",
          ...sx,
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (status === "error") {
    return (
      <Box
        sx={{
          display: "grid",
          height: `calc(100vh - ${60}px)`,
          placeItems: "center",
          ...sx,
        }}
      >
        <Typography color="error">Failed to load the dashboard.</Typography>
      </Box>
    );
  }

  return (
    <Box
      component="iframe"
      src={src}
      title={title}
      sx={{
        width: "100%",
        height: `calc(100vh - ${60}px)`,
        border: "none",
        ...sx,
      }}
    />
  );
};

ProtectedGrafanaFrame.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.object]),
};

ProtectedGrafanaFrame.defaultProps = {
  sx: undefined,
};

export default ProtectedGrafanaFrame;
